import {
  GET_MATERIAL,
  GET_MATERIAL_SUCCESS,
  GET_MATERIAL_FAIL,
  SAVE_MATERIAL,
  SAVE_MATERIAL_SUCCESS,
  SAVE_MATERIAL_FAIL,
  UPDATE_MATERIAL,
  UPDATE_MATERIAL_SUCCESS,
  UPDATE_MATERIAL_FAIL,
  DELETE_MATERIAL,
  DELETE_MATERIAL_SUCCESS,
  DELETE_MATERIAL_FAIL,
  CLEAN_MATERIAL,
  SAVE_MASSIVE_CHARGE,
  SAVE_MASSIVE_CHARGE_SUCCESS,
  SAVE_MASSIVE_CHARGE_ERROR,
} from "./actionTypes"

export const getMaterialList = filter => {
  return {
    type: GET_MATERIAL,
    payload: { filter },
  }
}
export const getMaterialListSuccess = materialList => ({
  type: GET_MATERIAL_SUCCESS,
  payload: materialList,
})

export const getMaterialListFail = error => ({
  type: GET_MATERIAL_FAIL,
  payload: error,
})

export const saveMaterial = material => ({
  type: SAVE_MATERIAL,
  payload: material,
})

export const saveMaterialSuccess = material => ({
  type: SAVE_MATERIAL_SUCCESS,
  payload: material,
})

export const saveMaterialFail = error => ({
  type: SAVE_MATERIAL_FAIL,
  payload: error,
})

export const updateMaterial = material => ({
  type: UPDATE_MATERIAL,
  payload: material,
})

export const updateMaterialSuccess = material => ({
  type: UPDATE_MATERIAL_SUCCESS,
  payload: material,
})

export const updateMaterialsFail = error => ({
  type: UPDATE_MATERIAL_FAIL,
  payload: error,
})

export const deleteMaterial = material => {
  return {
    type: DELETE_MATERIAL,
    payload: material,
  }
}
export const deleteMaterialSuccess = material => ({
  type: DELETE_MATERIAL_SUCCESS,
  payload: material,
})

export const deleteMaterialFail = error => ({
  type: DELETE_MATERIAL_FAIL,
  payload: error,
})

export const cleanMaterial = () => ({
  type: CLEAN_MATERIAL,
  payload: {},
})

export const saveMassiveCharge = lsMaterial => ({
  type: SAVE_MASSIVE_CHARGE,
  payload: lsMaterial,
})

export const saveMassiveChargeSuccess = lsMaterial => ({
  type: SAVE_MASSIVE_CHARGE_SUCCESS,
  payload: lsMaterial,
})

export const saveMassiveChargeFail = error => ({
  type: SAVE_MASSIVE_CHARGE_ERROR,
  payload: error,
})
